import React from "react";
import { Modal } from "antd";
import Button from "../common/button";
import Map from "./Map";
const CustomOkButton = ({ onClick }) => (
  <Button
    title="Save"
    onClick={onClick}
    className="bg-lightBlue !text-black w-full focus:bg-primaryBlue !focus:text-white sm:w-19 h-5.4 !hover:shadow-none"
  />
);

const CustomCancelButton = ({ onClick }) => (
  <Button
    title="No"
    onClick={onClick}
    className="bg-lightBlue hover:bg-lightBlue focus:bg-primaryBlue !focus:text-white w-full sm:w-19 h-5.4 !text-black"
  />
);
const MapModal = ({ onCancel, onOk, text, title }) => {
  return (
    <div>
      <Modal
        open={true}
        footer={null}
        maskClosable={true}
        closeIcon={null}
        className="space-y-6"
        width="900px"
        onCancel={onCancel}
      >
        <h3>{title}</h3>
        <p>{text}</p>
        <Map />
        <div className="flex space-x-2 sm:space-x-0 flex-row justify-between mt-2">
          <div className="invisible">
            <CustomCancelButton onClick={onCancel} />
          </div>
          <CustomOkButton onClick={onOk} />
        </div>
      </Modal>
    </div>
  );
};
export default MapModal;
